import { getAuthHeader } from "src/utils/superagent";
import { LocationConfig } from "src/types/location";
import request from "superagent";
import { SortOrder } from "antd/lib/table/interface";
import { FacilityStatus } from "src/types/facilityStatus";
import { environmentConfig } from "@src/appV2/environment";
import { FacilityWithQualifiedAgents, ShiftTypeStatus } from "./types";

export async function fetchFacilityStatus(): Promise<{
  statuses: FacilityStatus;
}> {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityProfile/status`)
    .set(await getAuthHeader());
  return body;
}

export async function fetchShiftFacilityStatus(
  facilityIds: string[]
): Promise<{ statusMap: Record<string, ShiftTypeStatus> }> {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/shift/facility/status`)
    .set(await getAuthHeader())
    .query({ facilities: facilityIds });

  return body;
}

export async function fetchFacilities({
  page,
  filter,
  sorter,
}: {
  page?: number;
  filter:
    | {
        locations: LocationConfig[];
        status: string;
      }
    | { users?: string };
  sorter?: {
    order?: SortOrder | undefined;
    field?: React.Key | readonly React.Key[] | undefined;
  };
}): Promise<FacilityWithQualifiedAgents[]> {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityprofile/list`)
    .set(await getAuthHeader())
    .query({
      page,
      filter,
      sorter,
      getUserCount: true,
      optionalColumns: [],
      isDetailedList: true,
    });

  return body;
}

export async function fetchFacilitiesCount(filter: {
  locations: LocationConfig[];
  status: string;
}): Promise<{ facilityCount: number }> {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityprofile/count`)
    .set(await getAuthHeader())
    .query({ filter });
  return body;
}

export interface RatingBreakdownItem {
  rating: 1 | 2 | 3 | 4 | 5;
  numberOfRatings: number;
}

export interface RatingAggregatesAttributes {
  numberOfRatings: number;
  avgRating: number;
  ratingsBreakdown: RatingBreakdownItem[];
}

export interface RatingAggregatesResponse {
  data: {
    id: string;
    attributes: RatingAggregatesAttributes;
  };
}

export interface WorkplaceComment {
  id: string;
  attributes: {
    text: string;
    workerInfo: {
      id?: string;
      name: string;
    };
    aggregates: {
      totalLikes: number;
      totalReplies: number;
    };
    createdAt: string;
    rating?: number;
  };
}

export interface WorkplaceCommentsResponse {
  data: WorkplaceComment[];
  links: {
    next?: string;
  };
}

export function isHttpError(err: unknown): err is { status: number } {
  return (
    typeof err === "object" &&
    err !== null &&
    "status" in err &&
    typeof (err as Record<string, unknown>).status === "number"
  );
}

function getShiftReviewApiUrl(): string {
  const url = environmentConfig.REACT_APP_SHIFT_REVIEW_API_URL;
  if (!url) {
    throw new Error("Missing REACT_APP_SHIFT_REVIEW_API_URL");
  }
  return url.replace(/\/$/, "");
}

export async function fetchWorkplaceRatingAggregates(
  facilityId: string
): Promise<RatingAggregatesResponse> {
  const shiftReviewApiUrl = getShiftReviewApiUrl();
  const { body } = await request
    .get(`${shiftReviewApiUrl}/workplaces/${encodeURIComponent(facilityId)}/rating-aggregates`)
    .set(await getAuthHeader());
  return body;
}

export async function fetchWorkplaceComments(
  facilityId: string,
  nextPageUrl?: string
): Promise<WorkplaceCommentsResponse> {
  const shiftReviewApiUrl = getShiftReviewApiUrl();
  const url =
    nextPageUrl ?? `${shiftReviewApiUrl}/workplaces/${encodeURIComponent(facilityId)}/comments`;
  if (nextPageUrl && !nextPageUrl.startsWith(shiftReviewApiUrl)) {
    throw new Error("Unexpected pagination URL origin");
  }
  const { body } = await request.get(url).set(await getAuthHeader());
  return body;
}
